import { JSONSchema7 } from 'json-schema';
import { WorkflowEngineMode } from '../../WorkflowEngine/workflowEngineReducer';
import { PagePermissionLevel } from '../Enums/pagePermissionLevel';
import JSONSchema7Properties from '../jSONSchema7Properties';
import PageState from '../pageState';
import getPagePermissionForRole from './getPagePermissionForRole';

export default (
  mode: WorkflowEngineMode,
  role: string,
  page: PageState
): boolean => {
  if (mode === WorkflowEngineMode.BUILD) return true;

  if (role.length === 0) return true;

  const pageSchema = (page.schema.properties as JSONSchema7Properties)[
    'page'
  ] as JSONSchema7;

  return (
    getPagePermissionForRole(pageSchema, role) !== PagePermissionLevel.NoAccess
  );
};
